import React from 'react';
import '../style.css';
export type TextIconProps = {
    icon: any;
    iconText: string;
    className: string;
}
export const TextIcon = ({ icon, iconText, className }: TextIconProps) => {

    return (
        <div className={`_247FactoryNet-textIcon ${className}`} >
            {icon ? <div className='icon'>
                {icon}
            </div> : ""}
            {iconText ? <div className='text'>
                {iconText}
            </div> : ""}
        </div>
    )
}